<template>
  <x-page title="多多盲盒规则" :loading="loading" no-safe-area>
    <div :class="_.page">
      <!-- 规则 -->
      <div :class="_.rule">
        <div :class="_.container">
          <div :class="_.title">盲盒规则</div>
          <div :class="_.content">{{ homeData.rule }}</div>
        </div>
      </div>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiBlindBoxHomeActivityIndex } from '@/api'
  import { mapQuery, prepareData, Track } from '@/utils'

  export default Vue.extend({
    mixins: [
      mapQuery({
        id: 'id',
      }),
      Track.provideMark(() => ({
        page: '多多盲盒规则页',
      })),
    ],

    data: () => ({
      loading: true,
      homeData: {},
    }),

    created() {
      this.prepareData()
    },

    methods: {
      async prepareData() {
        const { homeData } = await prepareData({
          homeData: apiBlindBoxHomeActivityIndex({
            id: this.id,
          }),
        })
        this.homeData = homeData
        this.loading = false
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    background: linear-gradient(360deg, #9c008e 0%, #6500e4 100%);
    min-height: 100%;
    padding: 30px 12px 12px 12px;
    box-sizing: border-box;

    .rule {
      position: relative;
      padding: 12px;
      background: #ae71f5;
      box-shadow: inset 0px 1px 10px 0px rgba(206, 169, 255, 1);
      border-radius: 8px;

      .container {
        background: #4b0ea8;
        border-radius: 8px;

        .title {
          position: absolute;
          top: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 188px;
          height: 43px;
          background-image: url('./images/标题背景.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          font-size: 18px;
          font-weight: bold;
          color: #740100;
          line-height: 25px;
          padding-top: 5px;
          text-align: center;
          box-sizing: border-box;
        }

        .content {
          font-size: 14px;
          color: #dabeff;
          line-height: 22px;
          padding: 37px 12px 12px 12px;
          white-space: pre-line;
        }
      }
    }
  }
</style>
